import Roles from '@/auth/roles';
import CategoryForm from './category-form';
import CategoryList from './category-list';
import CategoryHistoryFull from './category-history/category-history-full/category-history-full';
import CategoryHistorySingle from './category-history/category-history-single/category-history-single';
import CategoryShow from './category-show';
import CategoryImportcsv from './category-import-csv';

const roles = Roles.values;

export default [
  {
    name: 'categoryList',
    path: 'category',
    component: CategoryList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.categoryViewer.id,
        roles.categoryEditor.id
      ]
    },   
    children: [
    {
      name: 'categoryImportCsv',
      path: 'importCsv',
      components:  {
        categoryImport: CategoryImportcsv
      }
    }]
  },
  {
    name: 'categoryNew',
    path: 'category/new',
    component: CategoryForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.categoryEditor.id
      ]
    }
  },
  {
    name: 'categoryEdit',
    path: 'category/:id/edit',
    component: CategoryForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.categoryEditor.id
      ]
    }
  },
  {
    name: 'categoryHistorySingle',
    path: 'category/:id/history',
    component: CategoryHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'categoryHistoryFull',
    path: 'category/history',
    component: CategoryHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'categoryShow',
    path: 'category/:id',
    component: CategoryShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.categoryViewer.id,
        roles.categoryEditor.id
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/category/category-routes.js